import React, { useContext, useEffect } from "react";
import { getLocationService } from "src/core/services/location.service";
import LocationContext from "src/core/state/context/LocationContext";
import { GET_ALL_LOCATIONS } from "src/core/state/types/locations.type";

import AboutCustomers from "./components/AboutCustomers";
import ChooseRemit from "./components/ChooseRemit";
import DownloadAppSection from "./components/DownloadAppSection";
import Faq from "./components/Faq";

import HeroSection from "./components/HeroSection";
import HowItWorks from "./components/HowItWorks";
import Refer from "./components/Refer";
const WelcomeView = () => {
  const {
    location: { locations },
    locationDispatch,
  } = useContext(LocationContext);

  const getLocations = async () => {
      const locationRes = await getLocationService();
      if (locationRes) {
        locationDispatch({ type: GET_ALL_LOCATIONS, payload: locationRes });
      }
  };
  useEffect(() => {
    getLocations();
  }, []);

  return (
    <div>
      <HeroSection />
      <ChooseRemit />
      <HowItWorks />
      <DownloadAppSection />
      <Refer />
      <Faq />
      <AboutCustomers />
    </div>
  );
};

export default WelcomeView;
